export default {
    SearchConfiguration: {
        Code: 'Code',
        Index: 'Index',
        start: 'Effective start time',
        end: 'Effective end time',
        Description: 'Description',
        New: 'New',
        delete: 'Are you sure you want to delete the selected row?',
        add: {
            Query: 'Query',
            Custom: 'Custom parameter',
            Test: 'Test',
            enter: 'Please enter',
            Return: 'Return result:',
            Execute: 'Execute',
            entercode: 'Please enter a code',
            enterindex: 'Please enter the index',
            enterstart: 'Please enter the effective start time',
            enterend: 'Please enter the effective end time',
            successfully: 'Modified successfully',
            added: 'Successfully added',
            enterJSON: 'Please enter custom data of JSON type',
        }
    },
};
